<template>
  <a :href="value.url" target="_blank">{{ value.text }}</a>
</template>

<script>
export default {
  name: "LinkColumn",
  props: ["value"]
};
</script>

<style scoped></style>
